// extracted by mini-css-extract-plugin
module.exports = {"Contacts":"Contacts_Contacts__2ZxDR"};